module.exports = __webpack_public_path__ + "static/media/class.2dee5838.svg";